import { ResolverService } from './shared/resolver/resolver.service';
import { AuthGuardService } from './shared/auth-guard/auth-guard.service';
import { HeaderBodyFooterAdderComponent } from './theme/header-body-footer-adder/header-body-footer-adder.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BlockRouteResolverForSentryService } from './shared/blockRouteResolverForsentry/block-route-resolver-for-sentry.service';
import { HttpComponent } from './static-pages/http/http.component';
import { HttpErrorComponent } from './static-pages/http-error/http-error.component';
import { directLiginComponent } from './static-pages/direct-login/direct-login.component';

const routes: Routes = [
  // { path: '', redirectTo: '/', pathMatch: 'full' },

  {
    path: '',
    component: HeaderBodyFooterAdderComponent,
    children: [
      {
        path: '',
        // loadChildren: () => import('./dashboard-landing-page/dashboard-landing-page.module').then(m => m.DashboardLandingPageModule),
        loadChildren: () => import('./landing-page/landing-page.module').then(m => m.LandingPageModule),
        data: {
          title: 'Home',
          description: ''
        }
      },
      {
        path: 'login', resolve: { ResolverService }, loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
        data: {
          title: 'Login',
          description: ''
        }
      },
      {
        path: 'direct-login', component: directLiginComponent,
        data: {
          title: 'Login',
          description: ''
        }
      },
      {
        path: 'candidate-login', resolve: { ResolverService }, loadChildren: () => import('./candidate-login/candidate-login.module').then(m => m.candidateLoginModule),
        data: {
          title: 'Candidate Login',
          description: ''
        }
      },
      {
        path: 'http-error',component:HttpComponent,
        data: {
          title: 'HTTP-Error',
          description: ''
        }
      },
      {
        path: 'url-error',component:HttpErrorComponent,
        data: {
          title: 'URL-Error',
          description: ''
        }
      },
      // {
      //   path: 'candidate-registration',
      //   loadChildren: './candidate-registration/candidate-registration.module#CandidateRegistrationModule',
      //   data: {
      //     title: 'Candidate Registration',
      //     description: ''
      //   }

      // },
      {
        path: 'mela-registration',
        loadChildren: () => import('./apprenticeship-mela-registration/apprenticeship-mela-registration.module').then(m => m.ApprenticeshipMelaRegistrationModule),
        data: {
          title: 'Candidate/Establishment Registration',
          description: ''
        }

      },
      // {
      //   path: 'college-registration',
      //   loadChildren: './college-registration/college-registration.module#CollegeRegistrationModule',
      //   data: {
      //     title: 'College Registration',
      //     description: ''
      //   }

      // },
      {
        path: 'tpa-registration',
        loadChildren: () => import('./tpa-registration/tpa-registration.module').then(m => m.TpaRegistrationModule),
        data: {
          title: 'TPA Registration',
          description: ''
        }

      },
      {
        path: 'btp-registration',
        loadChildren: () => import('./btp-registration/btp-registration.module').then(m => m.BTPRegistrationModule),
        data: {
          title: 'BTP Registration',
          description: ''
        }

      },
      {
        path: 'order-status',
        loadChildren: () => import('./payment-order/payment-order.module').then(m => m.PaymentOrderModule),
        data: {
          title: 'Payment Information',
          description: ''
        }

      },
      {
        path: 'order-status/cancel',
        loadChildren: () => import('./payment-order/payment-order.module').then(m => m.PaymentOrderModule),
        data: {
          title: 'Payment Information',
          description: ''
        }

      },
      {
        path: 'establishment-registration',
        loadChildren: () => import('./establishment-registration/establishment-registration.module').then(m => m.EstablishmentRegistrationModule),
        data: {
          title: 'Establishment Registration',
          description: ''
        }
      },
      {
        path: 'pmnam-map',
        loadChildren: () => import('./apprenticeship-mela/apprenticeship-mela.module').then(m => m.ApprenticeshipMelaModule),
        data: {
          title: 'Apprenticeship Mela',
          description: ''
        }
      },
     
      // {
      //   path: 'order-details',
      //   loadChildren: './nimi-payment-status/nimi-payment-status.module#NimiPaymentStatusModule',
      //   data: {
      //     title: 'Payment Status',
      //     description: ''
      //   }
      // },
      {
        path: 'nimi/order-status',
        loadChildren: () => import('./nimi-payment-status/nimi-payment-status.module').then(m => m.NimiPaymentStatusModule),
        data: {
          title: 'Payment Status',
          description: ''
        }
      },
      {
        path: 'apprenticeship',
        loadChildren: () => import('./apprentice-opportunities/apprentice-opportunities.module').then(m => m.ApprenticeOpportunitiesModule),
        data: {
          title: 'All Opportunities',
          description: ' '
        }
      },
      {
        path: 'courses',
        loadChildren: () => import('./all-published-courses/all-published-courses.module').then(m => m.AllPublishedCoursesModule),
        data: {
          title: 'All Published Courses'
        }
      },
      { path: 'dashboard', resolve: { ResolverService }, loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
      {
        path: 'candidate',
        canLoad: [AuthGuardService],
        data: {
          allowedRole: 'candidate'
        },
        resolve: { BlockRouteResolverForSentryService },
        loadChildren: () => import('./candidate/candidate.module').then(m => m.CandidateModule)
      },
      {
        path: 'activate/:userId/:token',
        loadChildren: () => import('./dashboard-landing-page/dashboard-landing-page.module').then(m => m.DashboardLandingPageModule)
      },
      {
        path: 'activate-email/:userIdEmail/:tokenEmail',
        loadChildren: () => import('./dashboard-landing-page/dashboard-landing-page.module').then(m => m.DashboardLandingPageModule)
      },
      {
        path: 'apprentice/services',
        loadChildren: () => import('./apprentice-services/apprentice-services.module').then(m => m.ApprenticeServicesModule),
        data: {
          title: 'Apprentice Services'
        }
      },
    ]
  },
  {
    path: '', component: HeaderBodyFooterAdderComponent,
    children: [
      {
        path: '**', resolve: { ResolverService }, loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
        data: {
          title: 'Login',
          description: ''
        }
      },
    ]
  },
  // {
  //   path: '**', component: PageNotFoundComponent,
  //   data: {
  //     title: 'Page Not Found',
  //     description: ''
  //   }
  // }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
